import NotificationsTab from './NotificationsTab'

export default function NotificationsPage() {
  return <NotificationsTab />
}
